import { createAsyncThunk } from "@reduxjs/toolkit";
import { incentivationUsersApi, ActionModuleInstanceIncentivationRequest } from "../../api/incentivationUsersApi";
import { AppDispatch, RootState } from "../store";
import { handleRequest } from "../utils/handleRequest";
import i18n from "../../i18n";
import { CallResult } from "../../api/Requests";
import { EmployeeIncentivation } from "../../types/employeeScores";
import { Dayjs } from "dayjs";

export const saveIncentivationsThunk = createAsyncThunk<
  CallResult<any> | null,
  { actionModuleId: number; updates: ActionModuleInstanceIncentivationRequest[] },
  { dispatch: AppDispatch; state: RootState }
>(
  "incentivation/saveIncentivations",
  async ({ actionModuleId, updates }, { dispatch }) => {
    const result = await handleRequest(
      dispatch,
      "direct",
      () => incentivationUsersApi.editMultipleInstancesIncentivate(actionModuleId, updates),
      i18n.t("requestMessage.incentivationSaved")
    );
    return result.success() ? result : null;
  }
);

export const uploadIncentivationExcelThunk = createAsyncThunk<
  CallResult<any> | null,
  { actionModuleId: number; employeeScores: EmployeeIncentivation[], startDate: Dayjs, endDate: Dayjs },
  { dispatch: AppDispatch; state: RootState }
>(
  "incentivation/uploadIncentivationExcel",
  async ({ actionModuleId, employeeScores, startDate, endDate }, { dispatch }) => {
    const result = await handleRequest(
      dispatch,
      "direct",
      () => incentivationUsersApi.importEmployeeScoresAction(
        actionModuleId,
        employeeScores,
        startDate,
        endDate,
      ) as Promise<CallResult<any>>,
      i18n.t("requestMessage.incentivationExcelUploaded")
    );
    return result.success() ? result : null;
  }
);